import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedSection from '../../components/base/AnimatedSection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import BenefitsStrip from './components/BenefitsStrip';
import HowItWorks from './components/HowItWorks';
import PricingComparison from './components/PricingComparison';
import CredibilitySection from './components/CredibilitySection';
import IndustriesSection from './components/IndustriesSection';
import WhyDifferent from './components/WhyDifferent';
import Testimonials from './components/Testimonials';
import HomeFAQ from './components/HomeFAQ';
import StartLLCSection from './components/StartLLCSection';
import LeadMagnet from './components/LeadMagnet';
import FinalCTA from './components/FinalCTA';
import SchemaMarkup from '../../components/feature/SchemaMarkup';
import { useLanguageFromPath } from '../../hooks/useLanguageFromPath';
import ResultsSection from './components/ResultsSection';
import { SITE_ORIGIN } from '@/config/siteUrl';

export default function Home() {
  useLanguageFromPath();
  const { i18n } = useTranslation();

  useEffect(() => {
    const isEs = i18n.language === 'es';

    document.title = isEs
      ? 'Capital Empresarial al 0% de Interés | Guía Experta | Kailac'
      : '0% Interest Business Funding | Expert-Guided | Kailac';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        isEs
          ? 'Accede a financiamiento empresarial al 0% de interés por hasta 12 meses con guía experta. Kailac ayuda a emprendedores calificados a navegar programas de financiamiento con un proceso transparente, rápido y bilingüe EN/ES.'
          : 'Access 0% interest business funding for up to 12 months with expert guidance. Kailac helps qualified entrepreneurs navigate funding programs with a transparent, fast process. For qualified applicants only.'
      );
    }

    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute(
        'content',
        isEs
          ? 'financiamiento empresarial 0%, capital para negocios, crédito empresarial, asesoría financiera, LLC, emprendedores latinos'
          : '0% interest business funding, business capital, business credit, expert financial advisory, LLC, entrepreneurs'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute(
        'href',
        isEs ? `${SITE_ORIGIN}/es` : `${SITE_ORIGIN}/`
      );
    }

    // hreflang alternate tags for bilingual SEO
    let hreflangEn = document.querySelector('link[hreflang="en"]') as HTMLLinkElement | null;
    let hreflangEs = document.querySelector('link[hreflang="es"]') as HTMLLinkElement | null;

    if (!hreflangEn) {
      hreflangEn = document.createElement('link');
      hreflangEn.setAttribute('rel', 'alternate');
      hreflangEn.setAttribute('hreflang', 'en');
      document.head.appendChild(hreflangEn);
    }
    if (!hreflangEs) {
      hreflangEs = document.createElement('link');
      hreflangEs.setAttribute('rel', 'alternate');
      hreflangEs.setAttribute('hreflang', 'es');
      document.head.appendChild(hreflangEs);
    }
    hreflangEn.setAttribute('href', `${SITE_ORIGIN}/`);
    hreflangEs.setAttribute('href', `${SITE_ORIGIN}/es`);
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-[#FCFAFD] font-sans pb-16 lg:pb-0">
      <SchemaMarkup />
      <Navbar />
      <main>
        <Hero />
        <AnimatedSection>
          <BenefitsStrip />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <HowItWorks />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <PricingComparison />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <CredibilitySection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <IndustriesSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <WhyDifferent />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <Testimonials />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <ResultsSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <StartLLCSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <HomeFAQ />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <LeadMagnet />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <FinalCTA />
        </AnimatedSection>
      </main>
      <Footer />
    </div>
  );
}
